module.exports = __webpack_public_path__ + "static/media/morphology_comic.0328d44b.jpg";